"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../../core/utils");

var SelloutReleaseItemSnapshot_1 = require("../../model/sellout/SelloutReleaseItemSnapshot");

var SelloutReleaseItemPricesConverter_1 = require("./SelloutReleaseItemPricesConverter");

var SelloutReleaseItemSnapshotConverter_1 = require("./SelloutReleaseItemSnapshotConverter");

var SelloutReleaseItemSupplyDataConverter_1 = require("./SelloutReleaseItemSupplyDataConverter");

var SelloutReleaseItemSnapshotConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemSn) {
  _inherits(SelloutReleaseItemSnapshotConverterImpl, _SelloutReleaseItemSn);

  function SelloutReleaseItemSnapshotConverterImpl(releaseItemSupplyDataConverter, releaseItemPricesConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemSnapshotConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSnapshotConverterImpl).call(this));
    _this.releaseItemSupplyDataConverter = releaseItemSupplyDataConverter;
    _this.releaseItemPricesConverter = releaseItemPricesConverter;
    return _this;
  }

  _createClass(SelloutReleaseItemSnapshotConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseItemSnapshot_1.SelloutReleaseItemSnapshot(SelloutReleaseItemSnapshot_1.SelloutReleaseItemSnapshot.schema.snapshotTime.valueOfField(source), SelloutReleaseItemSnapshot_1.SelloutReleaseItemSnapshot.schema.exported.valueOfField(source), utils_1.Utils.isValueMissing(source.supplyData) ? null : SelloutReleaseItemSnapshot_1.SelloutReleaseItemSnapshot.schema.supplyData.valueOf(this.releaseItemSupplyDataConverter.toObject(source.supplyData, conversions)), conversions.asObject(source, 'prices', function (doc) {
        return _this2.releaseItemPricesConverter.toObject(doc, conversions);
      }));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        snapshotTime: conversions.fromDate(source.snapshotTime),
        exported: source.exported,
        supplyData: source.supplyData !== null ? this.releaseItemSupplyDataConverter.toDocument(source.supplyData, conversions) : null,
        prices: this.releaseItemPricesConverter.toDocument(source.prices, conversions)
      };
    }
  }]);

  return SelloutReleaseItemSnapshotConverterImpl;
}(SelloutReleaseItemSnapshotConverter_1.SelloutReleaseItemSnapshotConverter);

SelloutReleaseItemSnapshotConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutReleaseItemSupplyDataConverter_1.SelloutReleaseItemSupplyDataConverter, SelloutReleaseItemPricesConverter_1.SelloutReleaseItemPricesConverter])], SelloutReleaseItemSnapshotConverterImpl);
exports.SelloutReleaseItemSnapshotConverterImpl = SelloutReleaseItemSnapshotConverterImpl;